/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocsCatalogControllerContentQueryResponse, DocsCatalogControllerContentQueryParams } from "../../models/documentsController/DocsCatalogControllerContent";

function getDocsCatalogControllerContentUrl() {
  const res = { method: 'GET', url: `/api/v1/documents/docs/content` as const }  
  return res
}

/**
 * @summary Read one doc’s markdown by its catalog path
 * {@link /api/v1/documents/docs/content}
 */
export async function docsCatalogControllerContent(params: DocsCatalogControllerContentQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocsCatalogControllerContentQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getDocsCatalogControllerContentUrl().url.toString(), params, ... requestConfig })  
  return res.data
}